/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendDiscountRateDto } from '../models/backend-discount-rate-dto';
import { projectTaxesDiscountRatesCopyCreate } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create';
import { projectTaxesDiscountRatesCopyCreate$FormData } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create-form-data';
import { ProjectTaxesDiscountRatesCopyCreate$FormData$Params } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create-form-data';
import { ProjectTaxesDiscountRatesCopyCreate$Params } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create';
import { projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create-x-www-form-urlencoded';
import { ProjectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Params } from '../fn/discount-rate-copy/project-taxes-discount-rates-copy-create-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiDiscountRateCopyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesDiscountRatesCopyCreate()` */
  static readonly ProjectTaxesDiscountRatesCopyCreatePath = '/api/project_taxes/discount_rates/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCopyCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesCopyCreate$Response(
    params: ProjectTaxesDiscountRatesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCopyCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesCopyCreate(
    params: ProjectTaxesDiscountRatesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded(
    params: ProjectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCopyCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCopyCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesCopyCreate$FormData$Response(
    params: ProjectTaxesDiscountRatesCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCopyCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCopyCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesCopyCreate$FormData(
    params: ProjectTaxesDiscountRatesCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCopyCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }
}
